import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const DocsPageOrderedList: FunctionComponent = ( { ...rest } ) =>
{
    return <DocsPageOrderedListWrapper {...rest} />
};

export default DocsPageOrderedList;

const DocsPageOrderedListWrapper = styled.ol`
`;
